import { render, staticRenderFns } from "./Alimentacao.vue?vue&type=template&id=b5fbe8c8&"
import script from "./Alimentacao.vue?vue&type=script&lang=js&"
export * from "./Alimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports